<template>
    <div>
        <div class="row" style="margin:5px auto;">
            <p>By clicking logout button below, you will be logged out of all the USGBC and GBCI applications in this browser.</p>
            <p>Click the logout button below to continue logging out or cancel button to stay logged in.</p>
        </div>
        <div>
            <button class="btn btn-primary" type="button"
                @click="logout">
                Logout
            </button>
            <button class="btn logout-cancel" type="button"
                @click="$bvModal.hide('logoutConfirm')">
                Cancel
            </button>
        </div>
    </div>
</template>

<script>
export default {
    methods: {
        logout() {
            this.$bvModal.hide('logoutConfirm')
            this.peer.misc.blockScreen('Logging out the application...')
            this.$store.dispatch('api/invalidate')
            const redirectPathOrUrl = '/login'
            platformApi.doLogout(redirectPathOrUrl, (redirectUrl) => {
                document.location.href = redirectUrl || redirectPathOrUrl
            }, {
                'X-Signature': this.$api.getSignature('', platformApi.authInfo().clientKey)
            })
        }
    }
}
</script>

<style scoped>
.btn.logout-cancel {
    float: right;
}
</style>
